<exam-starter></exam-starter>
<div ui-view="exameditor"></div>
